import changeMatchStatus from './changeMatchStatus'
import getItems from './getItems'

export const changeMatchStatusPromise = changeMatchStatus
export const getItemsPromise = getItems
